import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowRight = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 20 20"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      d="M12.025 4.94165L17.0834 9.99998L12.025 15.0583"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.91669 10H16.9417"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
